const cookiesKeys = {
    hunter: "HutnerCookie",
    clientAuth: "clientAuth"
};
export default cookiesKeys;
